import type { ListInspirationsResponse } from "@nlc/shared-types";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

const LIBRARY_STALE_TIME_MS = 10 * 60 * 1000;

export function useInspirationsQuery(): UseQueryResult<ListInspirationsResponse> {
  return useQuery({
    queryFn: () =>
      apiClient.url("/inspirations").get().json<ListInspirationsResponse>(),
    queryKey: ["inspirations"],
    staleTime: LIBRARY_STALE_TIME_MS,
  });
}
